export const ADD_SELECTED_LABEL = "ADD_SELECTED_LABEL";
export const REMOVE_SELECTED_LABEL = "REMOVE_SELECTED_LABEL";
export const SET_CURRENT_LABEL = "SET_CURRENT_LABEL";
export const SET_SELECTED_LANGUAGE = "SET_SELECTED_LANGUAGE";
export const SET_KEYWORDS = "SET_KEYWORDS";
export const FETCH_RESULTS_INIT = "FETCH_RESULTS_INIT";
export const FETCH_RESULTS_FAIL = "FETCH_RESULTS_FAIL";
export const FETCH_RESULTS_SUCCESS = "FETCH_RESULTS_SUCCESS";
